import styled, { css } from 'styled-components';

interface IFormProps {
  hasError: boolean;
}

export const Container = styled.div``;

export const Input = styled.div`
  display: flex;

  input {
    height: 32px;
    padding: 0 24px;
    border: 0;
    border-radius: 3px 0 0 3px;
    color: #3a3a3a;
    border: 2px solid #fff;
    border-right: 0;

    font-size: 14px;
  }

  button {
    width: 43px;
    height: 32px;
    background: #848484;
    border-radius: 0 3px 3px 0;
    border: 0;
    color: #fff;
    font-weight: bold;
    transition: background-color 0.2s;
  }
`;

export const Title = styled.h1`
  font-size: 48px;
  color: #3a3a3a;
  margin-top: 80px;
  max-width: 500px;
  line-height: 56px;
`;

export const Form = styled.form<IFormProps>`
  margin-top: 40px;
  max-width: 700px;
  display: flex;

  input {
    flex: 1;
    height: 70px;
    padding: 0 24px;
    border: 0;
    border-radius: 5px 0 0 5px;
    color: #3a3a3a;
    border: 2px solid #fff;
    border-right: 0;
    ${props =>
      props.hasError &&
      css`
        border-color: #c53030;
      `}
    &::placeholder {
      color: #a8a8b3;
    }
  }
  button {
    width: 210px;
    height: 70px;
    background: #04d361;
    border-radius: 0 5px 5px 0;
    border: 0;
    color: #fff;
    font-weight: bold;
    transition: background-color 0.2s;

    &:hover {
      filter: brightness(0.9);
    }
  }
`;

export const Error = styled.span`
  display: block;
  color: #c53030;
  margin-top: 8px;
`;

export const Repositories = styled.div`
  margin-top: 80px;
  max-width: 700px;

  a {
    background: #fff;
    border-radius: 5px;
    width: 100%;
    padding: 24px;
    display: block;
    text-decoration: none;
    display: flex;
    align-items: center;
    transition: transform 0.2s;

    & + a {
      margin-top: 16px;
    }

    &:hover {
      transform: translateX(10px);
    }

    img {
      width: 64px;
      height: 64px;
      border-radius: 50%;
    }

    div {
      margin: 0 16px;
      flex: 1;
      strong {
        font-size: 20px;
        color: #3d3d4d;
      }

      p {
        font-size: 18px;
        color: #a8a8b3;
        margin-top: 4px;
      }
    }

    svg {
      margin-left: auto;
      color: #cbcbd6;
    }
  }
`;

export const Search = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: 40px 20px;
`;
